import type React from 'react'

import { useDesktopApp } from '@/modules/desktop/DesktopAppProvider.tsx'
import {
  OldDesktopAppDialog,
  isOutdated,
} from '@/modules/desktop/OldDesktopAppDialog.tsx'
import { SpecialOfferDialog } from '@/modules/licenses/components/dialogs/special-offer-dialog.tsx'
import { classNames } from '@/utils/helpers.ts'

import { PageHeader } from './page-header.tsx'

interface PageProps {
  title?: string | JSX.Element
  headerOptions?: React.ReactNode
  titleOptions?: React.ReactNode
  backToPage?: { name: string; url: string }
  children: React.ReactNode
  asideOptions?: React.ReactNode
  above?: React.ReactNode
  className?: string
  pageClassName?: string
  description?: React.ReactNode
  titleClassName?: string
}

export const Page = ({
  title,
  headerOptions,
  titleOptions,
  backToPage,
  children,
  asideOptions,
  description,
  above,
  className,
  pageClassName,
  titleClassName,
}: PageProps) => {
  const isHeaderRendered = !!title || !!headerOptions || !!description
  const { appVersion } = useDesktopApp()

  return (
    <>
      {asideOptions && (
        <aside className="border-r px-4 py-8">{asideOptions}</aside>
      )}
      <div
        className={classNames(
          'grid px-4 py-8 pb-14 xl:container lg:px-16 xl:mx-auto',
          pageClassName,
        )}
      >
        {above}
        {isHeaderRendered && (
          <PageHeader
            title={title}
            titleClassName={titleClassName}
            titleOptions={titleOptions}
            className={className}
            optionComponents={headerOptions}
            description={description}
            backToPage={backToPage}
          />
        )}
        <SpecialOfferDialog />
        {isOutdated(appVersion) && <OldDesktopAppDialog show={true} />}
        {children}
      </div>
    </>
  )
}
